import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { useDispatch } from 'react-redux';
import { setDayNumber } from '../../../../redux/slices/MenuDaySlice';
import { useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert';
import { getFoodMenu, getProductsShortage, updatePredictedPeoples } from './MenuService';
import { DayShortageItem } from './MenuTableComponents/DayShortageItem';
import { EditButton } from '../../../../components/buttons/EditButton';
import { getClientDayNumber } from '../userSettings/UserSettingsService';
import { DayPeopleForm } from './MenuTableComponents/DayPeopleForm';
import './MenuPage.css';
import { DayOrderedShortageItem } from './MenuTableComponents/DayOrderedShortageItem';

const MenuPage = () => {
    const { t } = useTranslation('monthMenu');
    const [monthMenu, setMonthMenu] = useState([]);
    const [shortage, setShortage] = useState([]);
    const [dayNumberToday, setDayNumberToday] = useState(1);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const alert = useAlert();
    const navigate = useNavigate();

    useEffect(() => {
        getFoodMenu()
            .then((response) => setMonthMenu(response.data))
            .catch(() => alert.error(t('alert:loadingError')))
            .finally(() => setLoading(false));
        getClientDayNumber()
            .then((response) => setDayNumberToday(response.data))
            .catch(() => alert.error(t('alert:loadingError')));
    }, []);

    const calculate = () => {
        setLoading(true);
        getProductsShortage()
            .then((response) => setShortage(response.data))
            .catch(() => alert.error(t('alert:loadingError')))
            .finally(() => setLoading(false));
    };

    const updatePeopleCount = (values) => {
        updatePredictedPeoples(values)
            .then(() => {
                setMonthMenu(prev => prev.map(day => {
                    if (day.dayNumber === values.dayOfMenu) {
                        return {
                            ...day,
                            predictedLittleOnes: values.littleOnes,
                            predictedOlderKids: values.olderKids,
                            predictedPreschoolers: values.preschoolers,
                            predictedWorkers: values.workers,
                        };
                    }
                    return day;
                }));
                alert.success(t('alert:peoplePrediction') + values.dayOfMenu);
                calculate();
            })
            .catch(() => alert.error(t('alert:saveError')));
    };

    const edit = (dayNumber) => {
        dispatch(setDayNumber({ dayNumber: dayNumber }));
        navigate('/editDay');
    };

    const getDayShortage = (dayNumber) => {
        return shortage.length > 0
            ? shortage.find(it => it.dayNumber === dayNumber)
            : null;
    };

    const getRecipesTitle = (day) => {
        return day.recipes.map((recipe, index) => (index + 1) + '. ' + recipe)
            .join('\n');
    };

    return (
        <>
            {loading ? (
                <Spinner animation='border' className='container' />
            ) : (
                <div className={'fixed-table-header'}>
                    <Table striped bordered hover>
                        <thead>
                        <tr className={'header-style'}>
                            <th rowSpan={2}>{t('dayNumber')}</th>
                            <th rowSpan={2}>{t('dayRecipesNames')}</th>
                            <th colSpan={4}>{t('predictedPeople')}</th>
                            <th colSpan={2}>{t('shortageList')}</th>
                            <th rowSpan={2}>
                                <button className={'button--main success-button'} onClick={calculate}>
                                    {t('common:buttons.calculate')}
                                </button>
                            </th>
                        </tr>
                        <tr className={'header-style'}>
                            <th>{t('littleOnes')}</th>
                            <th>{t('olderKids')}</th>
                            <th>{t('preschoolers')}</th>
                            <th>{t('workers')}</th>
                            <th>{t('orderedShortage')}</th>
                            <th>{t('shortage')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {monthMenu.map((day, index) => {
                            return (
                                <tr key={index}
                                    className={dayNumberToday === day.dayNumber ? 'menu-day-row today-row' : 'menu-day-row'}>
                                    <td key={index + 'number'} width={'4%'}>
                                        {day.dayNumber}
                                    </td>
                                    <td width={'15%'}>
                                    <span title={getRecipesTitle(day)}>
                                        {t('dayRecipes')} {day.recipes.length}
                                    </span>
                                    </td>
                                    <td>{day.predictedLittleOnes}</td>
                                    <td>{day.predictedOlderKids}</td>
                                    <td>{day.predictedPreschoolers}</td>
                                    <td>{day.predictedWorkers}</td>
                                    <td>
                                        <DayOrderedShortageItem shortage={getDayShortage(day.dayNumber)}></DayOrderedShortageItem>
                                    </td>
                                    <td>
                                        <DayShortageItem shortage={getDayShortage(day.dayNumber)}></DayShortageItem>
                                    </td>
                                    <td width={'14%'}>
                                        <DayPeopleForm onClick={updatePeopleCount}
                                                       day={day}>
                                        </DayPeopleForm>
                                        <EditButton onClick={() => edit(day.dayNumber)}></EditButton>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>
            )}
        </>
    );
};
export default MenuPage;
